import React from "react";

type Props = {
    query: string;
    text: string;
};

const WorkbenchNewHighlight: React.FC<Props> = ({ query, text }) => {
    const tokens = Array.from(
        new Set(
            query
                .trim()
                .split(/\s+/)
                .map((token) => token.toLowerCase())
                .filter((token) => token.length >= 2),
        ),
    ).sort((left, right) => right.length - left.length);

    if (!tokens.length) {
        return <>{text}</>;
    }

    const escapedTokens = tokens.map((token) =>
        token.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
    );
    const parts = text.split(new RegExp(`(${escapedTokens.join("|")})`, "gi"));
    const tokenSet = new Set(tokens);

    return (
        <>
            {parts.map((part, index) =>
                tokenSet.has(part.toLowerCase()) ? (
                    <strong
                        className="workbench-new-matched-text"
                        key={`${part}-${index}`}
                    >
                        {part}
                    </strong>
                ) : (
                    part
                ),
            )}
        </>
    );
};

export default WorkbenchNewHighlight;
